import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { UPLOAD_LOGO, UPDATE_BROKERAGE_LOGO, UPDATE_NAV_LOGO, REMOVE_BROKERAGE_LOGO, REMOVE_PERSONAL_LOGO } from "../../store/settings-actions";
import { mapState, mapActions } from "vuex";
import Err from "@Broker/@Routes/error";
import { S3_BUCKET_URL, showToast } from "@Shared/@Utils/constants";
import { defineComponent } from "@vue/composition-api";
import DOMPurify from "dompurify";
export default defineComponent({
  name: "UploadLogo",
  components: {
    SimpleButton
  },
  props: {
    settingsType: {
      type: String,
      required: true
    },
    logo: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      uploadingLogo: {
        loading: false,
        status: false
      },
      removingLogo: {
        loading: false,
        status: false
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("SettingsStore", ["brokerageData", "overrides"])), mapState("AccountStore", ["accountDetails"])), {}, {
    isBrokerageSettings() {
      return this.settingsType === "brokerage-settings";
    },
    isPersonalSettings() {
      return this.settingsType === "personal-settings";
    },
    brokerageSubdomain() {
      return this.brokerageData.subdomain;
    },
    personalSubdomain() {
      return this.accountDetails.accountSubdomain;
    },
    subdomainToUse() {
      return this.isBrokerageSettings ? this.brokerageSubdomain : this.personalSubdomain;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("SettingsStore", [UPLOAD_LOGO, UPDATE_BROKERAGE_LOGO, UPDATE_NAV_LOGO, REMOVE_PERSONAL_LOGO, REMOVE_BROKERAGE_LOGO])), {}, {
    async updateThemeLogo() {
      const time = new Date().getTime();
      const logoSrc = `${S3_BUCKET_URL}/portal-styles/${this.subdomainToUse}?${time}`;
      this.$emit("change-logo", logoSrc);
      showToast("success", "yourLogoHasBeenChanged");
      if (this.isBrokerageSettings) await this.UPDATE_BROKERAGE_LOGO();
      if (this.overrides.overrideLogo || this.isPersonalSettings) this.UPDATE_NAV_LOGO({
        logoSrc
      });
    },
    handleClickUploadLogo() {
      document.getElementById("selected-image").click();
    },
    async handleChangeLogo({
      target
    }) {
      try {
        let file = target.files[0];
        if (file.type == "image/svg+xml") {
          file = await this.sanitizeFile(file);
        }
        this.uploadingLogo.loading = true;
        await this.UPLOAD_LOGO({
          file,
          settingsType: this.settingsType
        });
        await this.updateThemeLogo();
        this.uploadingLogo.status = true;
      } catch (e) {
        this.uploadingLogo.status = false;
        Err.handle(e, {}, this.$t("settings.themeTab.yourLogoCouldNotBeUploaded"));
      } finally {
        this.uploadingLogo.loading = false;
      }
    },
    async sanitizeFile(file) {
      const fileContent = await new _Promise(resolve => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsText(file);
      });
      const sanitizedContent = DOMPurify.sanitize(fileContent);
      return new File([sanitizedContent], file.name, {
        type: file.type,
        lastModified: file.lastModified
      });
    },
    async removeLogo() {
      try {
        this.removingLogo.loading = true;
        if (this.isBrokerageSettings) {
          await this.REMOVE_BROKERAGE_LOGO();
        } else {
          await this.REMOVE_PERSONAL_LOGO();
        }
        await this.updateThemeLogo();
        this.removingLogo.status = true;
      } catch (e) {
        this.removingLogo.status = false;
      } finally {
        this.removingLogo.loading = false;
      }
    }
  })
});